import { useMemo } from "react";

const MOBILE_UA_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const useIsMobileUserAgent = () => {
  return useMemo(() => {
    if (typeof navigator === "undefined") return false;
    return MOBILE_UA_REGEX.test(navigator.userAgent);
  }, []);
};

export default useIsMobileUserAgent;
